<template>
    <div class="mgt20 v-flex">
        <!--收款码-->
        <div style="width: 230px;">
            <div class="payborder">
                <img style="max-width: 100%;" v-if="payCode != null && payCode != ''" :src="'./paycode/' + payCode" />
            </div>
            <IconMenu @click="uploadReceiveCode" class="mgt20" svgname="ic_upload" name="上传收款码" :iconSize="16">
            </IconMenu>
        </div>
        <div style="margin-left: 30px;">
            <div class="brd" style="margin-top: 0px;">
                <div class="subname">收款人姓名</div>
                <div class="binput">{{ realName }}</div>
                <div class="mgt20 vc-flex">
                    <IconMenu @click="changeRealName" class="" svgname="ic_edit1" name="更改" :iconSize="13"></IconMenu>
                </div>
            </div>
            <div class="brd">
                <div class="subname">佣金变动通知邮件</div>
                <div class="binput">{{ notifyEmail }}</div>
                <div class="mgt20 vc-flex">
                    <IconMenu @click="changeEmail" class="" svgname="ic_edit1" name="更改" :iconSize="13"></IconMenu>
                    <IconMenu @click="sendTestEmail" class="mgl20" svgname="ic_email" name="发送测试邮件" :iconSize="16">
                    </IconMenu>
                </div>
            </div>
        </div>
        <!--输入对话框-->
        <InputDialog :showDialog="inputDialog.show" :hint="inputDialog.hint" :defaultText="inputDialog.defaultText"
            :title="inputDialog.title" @selectButton="inputDialog.callBack"></InputDialog>
    </div>
</template>

<script>
import IconMenu from '@/components/IconMenu.vue';
import httpClient from '@/commom/http/httpClient';
import InputDialog from '@/components/dialog/InputDialog.vue';
export default {
    name: 'WithdrawSetting',
    components: {
        IconMenu,
        InputDialog
    },
    props: {

    },
    data() {
        return {
            payCode: "",
            realName: "",
            notifyEmail: "",
            ///输入对话框
            inputDialog: {
                show: false,
                title: "",
                hint: "",
                defaultText: "",
                callBack: null
            },
        }
    },
    mounted: function () {
        this.loadData()
    },
    methods: {
        ///加载数据
        loadData: function () {
            var that = this
            httpClient.invoke("ShareAPI.GetPaymentSetting", {}, function (res) {
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }

                that.payCode = res.payCode
                that.realName = res.realName
                that.notifyEmail = res.notifyEmail

            })
        },
        ///上传收款码
        uploadReceiveCode: function () {
            // 创建一个隐藏的 input 元素，类型是文件选择
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*'; // 限制只能选择图片文件
            // 监听用户选择文件事件
            var that = this
            input.onchange = () => {
                const file = input.files[0];
                if (!file) {
                    that.$message({
                        message: '未选择文件',
                        type: 'warning'
                    });
                    return;
                }
                const MAX_SIZE = 1 * 1024 * 1024; // 1MB
                // 文件大小限制判断
                if (file.size > MAX_SIZE) {
                    that.$message({
                        message: '文件大小不能超过1MB',
                        type: 'warning'
                    });
                    return;
                }


                const reader = new FileReader();

                // 读取文件完成后触发
                reader.onload = (e) => {
                    const base64 = e.target.result; // 这里就是图片的 base64 编码字符串
                    console.log('读取到的 base64:', base64);

                    var req = {
                        paycode: base64
                    }

                    httpClient.invoke("ShareAPI.UploadPayCode", req, function (res) {
                        if (res.error) {
                            that.$message.error(res.error)
                            return
                        }
                        if (!res.success) {
                            that.$message.error("上传收款码失败")
                            return
                        }
                        that.$message.success("上传收款码成功")
                        that.loadData()
                    })
                };

                // 读取文件为 DataURL（base64）
                reader.readAsDataURL(file);
            };

            // 触发文件选择对话框
            input.click();
        },
        ///更改收款人姓名
        changeRealName: function () {
            var that = this
            that.inputDialog.show = true
            that.inputDialog.title = "更改姓名"
            that.inputDialog.hint = "请输入收款人姓名"
            that.inputDialog.defaultText = that.realName
            that.inputDialog.callBack = function (inputRes) {
                that.inputDialog.show = false
                if (!inputRes.confrim) {
                    return
                }
                var model = {
                    realName: inputRes.text
                }
                var req = {
                    model: JSON.stringify(model)
                }
                httpClient.invoke("ShareAPI.UpdateShareInfo", req, function (res) {
                    if (res.error) {
                        that.$message.error(res.error)
                        return
                    }
                    if (!res.success) {
                        that.$message.error("更新失败")
                        return
                    }
                    that.$message.success("更新成功")
                    that.realName = inputRes.text
                })
            }
        },
        ///更改通知邮件
        changeEmail: function () {
            var that = this
            that.inputDialog.show = true
            that.inputDialog.title = "更改邮箱"
            that.inputDialog.hint = "请输入邮箱"
            that.inputDialog.defaultText = that.notifyEmail
            that.inputDialog.callBack = function (inputRes) {
                that.inputDialog.show = false
                if (!inputRes.confrim) {
                    return
                }
                var model = {
                    notifyEmail: inputRes.text
                }
                var req = {
                    model: JSON.stringify(model)
                }
                httpClient.invoke("ShareAPI.UpdateShareInfo", req, function (res) {
                    if (res.error) {
                        that.$message.error(res.error)
                        return
                    }
                    if (!res.success) {
                        that.$message.error("更新失败")
                        return
                    }
                    that.$message.success("更新成功")
                    that.notifyEmail = inputRes.text
                })
            }
        },
        ///发送测试邮件
        sendTestEmail: function () {
            var that = this
            var req = {
            }
            httpClient.invoke("ShareAPI.SendTestNotifyEmail", req, function (res) {
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }
                if (!res.success) {
                    that.$message.error("发送失败")
                    return
                }
                that.$message.success("发送成功")
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.payborder {
    height: 230px;
    background: var(--ek-card-color1);
    border: 1px solid var(--ek-split-lineColor);
    display: flex;
    align-items: center;
    justify-content: center;
}

.brd {
    margin-top: 30px;
    width: 230px;
}

.subname {
    font-size: 14px;
    color: var(--ek-text-color2);
}

.binput {
    margin-top: 10px;
    background: var(--ek-input-backColor);
    padding-left: 15px;
    line-height: 35px;
    border-radius: 5px;
    color: var(--ek-text-color1);
    font-size: 14px;
    height: 35px;
}
</style>
